import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {
  getFlatPopularChannelIntegrationTypes,
  getFlatPopularIntegrationTypes,
  getFlatPopularPluginIntegrationTypes,
  getFlatRecentlyAddedIntegrationTypes,
  getIsIntegrationTypesLoading,
} from '../../../store/data/integrationTypes/integrationTypesSelectors';
import {SettingsAppsCollectionsPage} from './settingsAppsCollectionsPage';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  popularIntegrationTypes: getFlatPopularIntegrationTypes,
  popularPluginIntegrationTypes: getFlatPopularPluginIntegrationTypes,
  popularChannelIntegrationTypes: getFlatPopularChannelIntegrationTypes,
  recentlyAddedIntegrationTypes: getFlatRecentlyAddedIntegrationTypes,
  isIntegrationTypesLoading: getIsIntegrationTypesLoading,
}));

export const SettingsAppsCollectionsPageContainer = connect(mapStateToProps)(SettingsAppsCollectionsPage);
